<svelte:options />

<script lang="ts">
  import type { Segment } from './sidebar.types';
  import {
    isSidebarOpen,
    selectedFeature,
    selectFeature,
  } from './sidebar-service';

  export let data: Segment;

  const mediumIconStyle = 'width: 24px; height: 24px; fill: white;';

  function generateIcon(iconname: string): string {
    return `${iconname} size="2rem"`;
  }

  function handleClick() {
    selectFeature(data.code);
  }
</script>

{#if data}
  <a
    aria-label={data.label}
    class="mc-sidebar-segment {data.code === $selectedFeature?.lv0?.code
      ? 'is-selected'
      : ''} {$isSidebarOpen ? 'is-open' : 'is-close'}"
    href={data.href ?? 'javascript:void(null)'}
    id={data.code}
    on:click={handleClick}
  >
    <div class="mc-sidebar-segment__container">
      {#if data.icon}
        {@html `<${generateIcon(
          data.icon,
        )} class="mc-sidebar-segment__icon" style="${mediumIconStyle}" />`}
      {/if}
      <span aria-hidden={!$isSidebarOpen} class="mc-sidebar-segment__text">
        {data.label}
      </span>
    </div>
  </a>
{/if}

<style lang="scss">
  @import './sidebar-variables';

  .mc-sidebar-segment {
    cursor: pointer;
    flex: 0;
    text-decoration: none;
    color: white;
    line-height: 22px;
    display: flex;
    overflow: hidden;
    min-height: 40px;

    span {
      width: 200px;
      min-width: 200px;
    }

    &__container {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 8px 0px;
    }

    &__icon {
      fill: white;
    }

    &__text {
      margin-left: 10px;
    }

    &.is-selected {
      background: $selected-Link;
    }

    :last-child {
      margin-left: 10px;
    }

    &:focus-visible {
      box-shadow: none;
      border: none;
      outline: none;

      .mc-sidebar-segment__container {
        box-shadow: none;
        border: none;
        border-radius: 6px;
        outline: 1px solid #0b96cc;
      }
    }

    &:hover {
      background: #405d68;
    }

    &.is-close {
      .mc-sidebar-segment__container {
        @include transition(margin 300ms ease-in-out);
        margin: 0 20px;
        width: 24px;
      }

      .mc-sidebar-segment__text {
        opacity: 0;
      }
    }

    &.is-open {
      .mc-sidebar-segment__container {
        @include transition(margin 300ms ease-in-out);
        margin: 0 32px;
      }

      .mc-sidebar-segment__text {
        opacity: 1;
      }
    }
  }
</style>
